/**
 * Menu component
 * 
 * @module component-menu
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = 'component-menu';

if (!customElements.get(customElements.component)) {

    class ComponentMenu extends HTMLElement {


        /**
         * Menu web component
         * 
         * @constructor
         */
        constructor() {

            super();

            this.closeMenu();
            this.initToggle();
            this.initSubmenu();
            // changed when added garage page menu
            // this.setOnTop();
            setTimeout(() => this.setOnTop(), 1000); // Set a delay before setting the position

        }

        /**
         * Init menu toggle buttons
         * 
         * @return {undefined}
         */
        initToggle() {

            document.querySelectorAll('[data-menu-open]').forEach((element) => {

                element.addEventListener('click', (event) => {
                    event.preventDefault();
                    this.openMenu();
                    this.activeToggle = event.target;
                });
            });

            document.querySelectorAll('[data-menu-close]').forEach((element) => {

                element.addEventListener('click', () => {
                    this.closeMenu();
                });
            });

            // Close menu on window resize
            window.addEventListener('screen-breakpoint', event => {
                this.closeMenu();
            });

            // Close menu on press escape
            window.addEventListener('escape', event => {
                this.closeMenu();
            });
        }

        /**
         * Open menu
         * 
         * @return {undefined}
         */
        openMenu() {

            this.classList.remove('hidden');

            document.body.classList.add('menu-active');

            document.querySelector('.menu__overlay').classList.add('active');

            this.setAttribute('aria-hidden', 'false');

            this.openStatus = true;

            setTimeout(() => {

                this.classList.add('active');

                this.initFocusTrap();

                this.activeFocusTrap();

                this.querySelector('[data-menu-close]').focus();

            }, 50);
        }

        /**
         * Close menu
         * 
         * @return {undefined}
         */
        closeMenu() {

            this.closeAllSubmenus();
            this.disableSubmenuFocusTrap();

            this.disableFocusTrap();

            this.classList.remove('active');

            document.body.classList.remove('menu-active');

            document.querySelector('.menu__overlay').classList.remove('active');

            if (window.screenMode == 'desktop-large') {

                this.setAttribute('aria-hidden', 'false');
                this.classList.remove('hidden');
                this.openStatus = true;

            } else {

                // We need to use set time out to avoid issues with menu animation
                setTimeout(() => {

                    this.setAttribute('aria-hidden', 'true');

                    if (this.openStatus && this.activeToggle) {
                        this.activeToggle.focus();
                    }

                    this.openStatus = false;

                    this.classList.add('hidden');
                }, 500);
            }
        }

        /**
         * Init submenus
         * 
         * @return {undefined}
         */
        initSubmenu() {
            this.closeAllSubmenus();

            // Open submenu on click
            document.querySelectorAll('[data-menu-submenu-target]').forEach((element) => {
                element.addEventListener('click', (event) => {
                    const isClosets = element.dataset.menuSubmenuTarget === "closets";

                    if (isClosets) {
                        event.preventDefault(); // <-- prevent URL navigation for 'closets'

                        console.log("Opening hidden snippet for closets");
                        const hiddenSnippet = document.querySelector('[data-hidden-snippet-mobile="closets"]');
                        if (hiddenSnippet) {
                            hiddenSnippet.classList.add('visible');
                        }
                    }
                    this.activeSubmenu = event.target;
                    let submenu = document.querySelector('[data-menu-submenu="' + element.dataset.menuSubmenuTarget + '"]');

                    this.openSubmenu(submenu);
                    this.togglePlusMinus(element, false); // Show minus icon
                });
            });

            // ALSO handle click for hover targets (like 'closets')
            document.querySelectorAll('[data-menu-submenu-target-hover]').forEach((element) => {
                element.addEventListener('click', (event) => {
                    const target = element.dataset.menuSubmenuTargetHover;

                    if (target === 'closets' && window.innerWidth <= 1199) {
                        event.preventDefault(); // Block default navigation
                        const submenu = document.querySelector(`[data-menu-submenu="${target}"]`);
                        const hiddenSnippet = document.querySelector(`[data-hidden-snippet-mobile="${target}"]`);

                        const isVisible = hiddenSnippet.classList.contains('visible');

                        if (isVisible) {
                            console.log('is visible');
                            // 🔻 Close submenu if already open
                            if (hiddenSnippet) hiddenSnippet.classList.remove('visible');
                            this.togglePlusMinus(element, true); // show +
                            this.disableSubmenuFocusTrap();
                        } else {
                            // 🔺 Open submenu
                            if (hiddenSnippet) hiddenSnippet.classList.add('visible');
                            this.openSubmenu(submenu);
                            this.togglePlusMinus(element, false); // show -
                        }
                    }
                });
            });


            // Open submenu on hover only on desktop
            document.querySelectorAll('[data-menu-level1-link]').forEach((element) => {
                if (element.dataset.menuSubmenuTargetHover) {
                    const hoverTarget = element.dataset.menuSubmenuTargetHover;
                    const hiddenSnippet = document.querySelector(`[data-hidden-snippet="${hoverTarget}"]`);
                    const submenu = document.querySelector(`[data-menu-submenu="${hoverTarget}"]`);

                    if (hoverTarget === 'closets' && hiddenSnippet) {
                        hoverintent(element, () => {
                            if (window.screenMode == 'desktop-large') {
                                hiddenSnippet.classList.add('visible');
                            }
                        }, () => {
                            if (window.screenMode == 'desktop-large') {
                                setTimeout(() => {
                                    if (!hiddenSnippet.matches(':hover') && !element.matches(':hover')) {
                                        hiddenSnippet.classList.remove('visible');
                                    }
                                }, 100);
                            }
                        });

                        hoverintent(hiddenSnippet, () => {
                            if (window.screenMode == 'desktop-large') {
                                hiddenSnippet.classList.add('visible');
                            }
                        }, () => {
                            if (window.screenMode == 'desktop-large') {
                                setTimeout(() => {
                                    if (!hiddenSnippet.matches(':hover') && !element.matches(':hover')) {
                                        hiddenSnippet.classList.remove('visible');
                                    }
                                }, 100);
                            }
                        });
                    } else if (submenu) {
                        hoverintent(element, () => {
                            if (window.screenMode == 'desktop-large') {
                                this.openSubmenu(submenu, true);
                            }
                        }, () => {
                            if (window.screenMode == 'desktop-large') {
                                setTimeout(() => {
                                    if (!submenu.matches(':hover') && !element.matches(':hover')) {
                                        this.closeSubmenu(submenu);
                                    }
                                }, 100);
                            }
                        });

                        hoverintent(submenu, () => {
                            if (window.screenMode == 'desktop-large') {
                                submenu.classList.add('active');
                            }
                        }, () => {
                            if (window.screenMode == 'desktop-large') {
                                setTimeout(() => {
                                    if (!submenu.matches(':hover') && !element.matches(':hover')) {
                                        this.closeSubmenu(submenu);
                                    }
                                }, 100);
                            }
                        });
                    }
                } else {
                    hoverintent(element, () => {
                        if (window.screenMode == 'desktop-large') {
                            this.closeAllSubmenus();
                        }
                    }, () => { });
                }
            });

            // Close submenu on click
            document.querySelectorAll('[data-menu-submenu-close-target]').forEach((element) => {
                element.addEventListener('click', (event) => {
                    event.preventDefault();
                    let submenu = document.querySelector('[data-menu-submenu="' + element.dataset.menuSubmenuCloseTarget + '"]');
                    this.closeSubmenu(submenu).then(result => {
                        this.disableSubmenuFocusTrap();
                        if (this.activeSubmenu) {
                            this.activeSubmenu.focus();
                            this.activeSubmenu = null;
                        }
                    });
                    this.disableGlobalOverlay();
                    this.togglePlusMinus(element, true); // Show plus icon

                    // Check if the target is "closets" and hide hidden snippet on mobile
                    if (element.dataset.menuSubmenuCloseTarget === "closets") {
                        console.log("Closing hidden snippet for closets");
                        const hiddenSnippet = document.querySelector('[data-hidden-snippet-mobile="closets"]');
                        if (hiddenSnippet) {
                            hiddenSnippet.classList.remove('visible');
                        }
                    }
                });
            });

            // Close submenu on leave hover only on desktop
            document.querySelector('.site-header').addEventListener('mouseleave', (event) => {
                if (window.screenMode == 'desktop-large') {
                    this.closeAllSubmenus();
                    this.disableSubmenuFocusTrap();
                }
            });

            // Close desktop megamenu when hover anywhere else
            const closetsSnippet = document.querySelector('[data-hidden-snippet="closets"]');

            if (closetsSnippet) {
                closetsSnippet.addEventListener('mouseleave', () => {
                    if (window.screenMode == 'desktop-large') {
                        closetsSnippet.classList.remove('visible');
                    }
                });
            }

            // Make entire submenu button clickable on mobile
            document.querySelectorAll('.menu__submenu-button').forEach((wrapper) => {
                wrapper.addEventListener('click', (event) => {
                    if (window.innerWidth <= 1199) {
                        event.preventDefault();

                        const plusBtn = wrapper.querySelector('[data-toggle="plus"]');
                        const minusBtn = wrapper.querySelector('[data-toggle="minus"]');
                        const target = plusBtn?.dataset.menuSubmenuTarget || minusBtn?.dataset.menuSubmenuCloseTarget;

                        if (!target) return;

                        const submenu = document.querySelector(`[data-menu-submenu="${target}"]`);
                        const hiddenSnippet = document.querySelector(`[data-hidden-snippet-mobile="${target}"]`);

                        const isOpen = submenu.classList.contains('active') || hiddenSnippet?.classList.contains('visible');

                        if (isOpen) {
                            // Close submenu
                            this.closeSubmenu(submenu);
                            if (hiddenSnippet) hiddenSnippet.classList.remove('visible');
                            this.togglePlusMinus(plusBtn || minusBtn, true); // show +
                        } else {
                            // Open submenu
                            this.openSubmenu(submenu);
                            if (hiddenSnippet) hiddenSnippet.classList.add('visible');
                            this.togglePlusMinus(plusBtn || minusBtn, false); // show -
                        }
                    }
                });
            });


        }





        /**
     * Toggle plus and minus icons visibility for mobile
     * 
     * @param {object} button The button element that was clicked.
     * @param {boolean} showPlus Boolean to show plus icon or not.
     * @return {undefined}
     */
        togglePlusMinus(button, showPlus) {
            if (!button) return;
            const menuButton = button.closest('.menu__submenu-button');
            if (menuButton) {
                const plusButton = menuButton.querySelector('[data-toggle="plus"]');
                const minusButton = menuButton.querySelector('[data-toggle="minus"]');
                if (plusButton && minusButton) {
                    if (showPlus) {
                        plusButton.style.display = '';
                        minusButton.style.display = 'none';
                    } else {
                        plusButton.style.display = 'none';
                        minusButton.style.display = '';
                    }
                }
            }
        }



        /**
         * Open a submenu
         * 
         * @param {object} submenu A submenu object.
         * @param {boolean} disable_focus Disable focus change after open the submenu.
         * @return {Promise} Boolean value.
         */
        openSubmenu(submenu, disable_focus = false) {

            return new Promise((resolve, reject) => {

                // Close all submenus opened
                this.closeAllSubmenus(submenu);

                // Handle submenu attributes
                submenu.classList.add('active');
                submenu.classList.add('animation');
                submenu.setAttribute('aria-hidden', 'false');
                submenu.classList.remove('hidden');

                // Handle global attributes
                this.classList.add('active-submenu');
                document.querySelector('body').classList.add('active-menu');

                if (window.screenMode != 'desktop-large') {

                    // Fix scroll position to top
                    this.querySelector('.menu__navigation-wrapper').scrollTop = 0;
                }

                this.enableGlobalOverlay();

                // We need to use set time out to avoid issues with animation
                setTimeout(() => {

                    if (!disable_focus) {
                        this.initSubmenuFocusTrap(submenu);
                        this.activeSubmenuFocusTrap();
                        submenu.querySelector('[data-menu-submenu-close-target]').focus();
                    }

                    resolve(true);
                }, 100);
            });
        }

        /**
     * Close a submenu
     * 
     * @param {object} submenu A submenu object.
     * @return {Promise} Boolean value.
     */
        closeSubmenu(submenu) {
            return new Promise((resolve, reject) => {
                // Handle submenu attributes
                submenu.classList.remove('active');

                // Handle global attributes
                this.classList.remove('active-submenu');
                document.querySelector('body').classList.remove('active-menu');

                // Check if the submenu is "closets" and hide hidden snippet
                if (submenu.dataset.menuSubmenu === "closets") {
                    console.log("hidden snippet");
                    const hiddenSnippet = document.querySelector('[data-hidden-snippet="closets"]');
                    if (hiddenSnippet) {
                        hiddenSnippet.classList.remove('visible');
                    }
                }

                // We need to use set time out to avoid issues with animation
                setTimeout(() => {
                    // Handle submenu attributes
                    submenu.setAttribute('aria-hidden', 'true');
                    submenu.classList.remove('animation');
                    submenu.classList.add('hidden');
                    resolve(true);
                }, 150);
            });
        }


        /**
         * Close all submenus
         * 
         * @param {object} submenuActived The active submenu.
         * @return {undefined}
         */
        closeAllSubmenus(submenuActived) {

            let submenus = document.querySelectorAll('[data-menu-submenu]');

            submenus.forEach(submenu => {

                if (submenuActived) {
                    // This condition will avoid closing the active submenu
                    if (submenuActived.dataset.menuSubmenu !== submenu.dataset.menuSubmenu) {
                        this.closeSubmenu(submenu).then(() => {
                            const toggleBtn = document.querySelector(`[data-menu-submenu-target="${submenu.dataset.menuSubmenu}"]`);
                            if (toggleBtn) this.togglePlusMinus(toggleBtn, true);
                        });
                    }
                } else {
                    this.closeSubmenu(submenu).then(() => {
                        const toggleBtn = document.querySelector(`[data-menu-submenu-target="${submenu.dataset.menuSubmenu}"]`);
                        if (toggleBtn) this.togglePlusMinus(toggleBtn, true);
                    });
                }
            });

            // Ensure the plus sign is shown for the closets submenu if it's closed
            const closetsSnippet = document.querySelector('[data-hidden-snippet-mobile="closets"]');
            const closetsToggle = document.querySelector('[data-menu-submenu-target="closets"]');

            // Remove 'visible' class from the hidden snippet for 'closets' only if a different submenu is activated
            if (closetsSnippet && closetsToggle && submenuActived && submenuActived.dataset.menuSubmenu !== "closets") {
                closetsSnippet.classList.remove('visible');
                this.togglePlusMinus(closetsToggle, true);
            }

            this.disableGlobalOverlay();
        }


        /**
         * Enable global overlay
         * 
         * @return {undefined}
         */
        enableGlobalOverlay() {

            if (window.screenMode == 'desktop-large') {
                document.querySelector('[data-global-overlay]').classList.add('active');
            }
        }

        /**
         * Disable global overlay
         * 
         * @return {undefined}
         */
        disableGlobalOverlay() {

            if (window.screenMode == 'desktop-large') {
                document.querySelector('[data-global-overlay]').classList.remove('active');
            }
        }

        /**
         * Init menu focus trap
         * 
         * @return {undefined}
         */
        initFocusTrap() {

            this.focusTrap = focusTrap.createFocusTrap(this, { clickOutsideDeactivates: true });
        }

        /**
         * Disable menu focus trap
         * 
         * @return {undefined}
         */
        disableFocusTrap() {

            if (this.focusTrap) {
                this.focusTrap.deactivate();
            }
        }

        /**
         * Ative menu focus trap
         * 
         * @return {undefined}
         */
        activeFocusTrap() {

            if (this.focusTrap) {
                this.focusTrap.activate();
            }
        }

        /**
         * Init submenu focus trap
         * 
         * @return {undefined}
         */
        initSubmenuFocusTrap(submenu) {

            this.submenuFocusTrap = focusTrap.createFocusTrap(submenu, { clickOutsideDeactivates: true });
        }

        /**
         * Active submenu focus trap
         * 
         * @return {undefined}
         */
        activeSubmenuFocusTrap() {

            if (this.submenuFocusTrap) {

                this.disableFocusTrap();
                this.submenuFocusTrap.activate();
            }
        }

        /**
         * Disable submenu focus trap
         * 
         * @return {undefined}
         */
        disableSubmenuFocusTrap() {

            if (this.submenuFocusTrap) {

                this.submenuFocusTrap.deactivate();
                this.submenuFocusTrap = null;

                if (window.screenMode != 'desktop-large') {
                    this.initFocusTrap();
                    this.activeFocusTrap();
                }
            }
        }

        /**
       * Set header on top
       * 
       * @return {undefined}
       */
        // changed when added garage page menu
        // setOnTop() {
        //     setTimeout(() => {
        //         let headerHeight = document.querySelector('#shopify-section-header').offsetHeight;
        //       console.log(headerHeight)
        //         let top = headerHeight.toString() + 'px';
        //         this.querySelector('.menu__container').style.top = top;
        //         this.querySelector('.menu__overlay').style.top = top;
        //     }, 5);
        // }
        setOnTop() {
            var divElement = document.querySelector('#shopify-section-header');
            if (divElement) {
                let headerHeight = divElement.offsetHeight;
                // console.log(headerHeight);
                let top = headerHeight.toString() + 'px';
                this.querySelector('.menu__container').style.top = top;
                this.querySelector('.menu__overlay').style.top = top;
            } else {
                // console.log("The element with 'shopify-section-header' id does not exist. Retrying in 1 second...");
                setTimeout(() => this.setOnTop(), 1000);
            }
        }
    }

    customElements.define(customElements.component, ComponentMenu);

    window.closeMenuGlobally = function () {
        console.log('Attempting to close the menu...');
        const menu = document.querySelector('component-menu'); // ensure this matches your component's tag
        console.log('Menu found:', menu);
        if (menu) {
            menu.closeMenu();
        } else {
            console.error("Menu component not found!");
        }
    }

}